import { EqMagModal } from './EqMagModal';

export const EqUnkMagModal = EqMagModal({
  title: 'Unknown Magnitude',
  desc: 'The computational method for the earthquake magnitude was unknown and could not be determined from the published sources.',
});
